import { render } from "./CostiNoteSpesaSottoProgetto.vue?vue&type=template&id=376ef0b4&scoped=true&ts=true"
import script from "./CostiNoteSpesaSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./CostiNoteSpesaSottoProgetto.vue?vue&type=script&lang=ts"

import "./CostiNoteSpesaSottoProgetto.vue?vue&type=style&index=0&id=376ef0b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376ef0b4"]])

export default __exports__